import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';
import { animate, stagger, onScroll } from 'animejs';

const moduleSelector = '.service-cards';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      if (!query.data) return;

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
          ${item.button_link ? `<a href="${item.button_link}" class="splide__slide">` : '<div class="splide__slide">'}
            <div class="service-card">
              ${item.background ? `<div class="image-wrapper">
                <img src="${item.background}" alt="${item.title}">
              </div>` : ''}
              <div class="content-wrapper">
                ${item.title ? `<h3 class="title">${item.title}</h3>` : ''}
                ${item.text ? `<p class="description">${item.text}</p>` : ''}
                ${item.button_text ? `<p class="btn-custom primary">${item.button_text}</p>` : ''}
              </div>
            </div>
          ${item.button_link ? '</a>' : '</div>'}
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

(() => {
  document.querySelectorAll('.service-cards .splide').forEach((item) => {
    const moreThanThree = item.querySelectorAll('.splide__slide').length > 3;
    const slider = new Splide(item, {
      type: 'slide',
      rewind: true,
      perPage: 3,
      perMove: 1,
      gap: 20,
      pagination: true,
      arrows: false,
      drag: moreThanThree,
      autoplay: true,
      breakpoints: {
        1200: {
          drag: true,
          perPage: 2,
        },
        768: {
          perPage: 1,
        },
      },
    });
    slider.mount();
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();

(() => {
  animate('.anime-custom .splide__slide.is-visible', {
    y: ['100px', 0],
    delay: stagger(500),
    autoplay: onScroll({
      enter: 'end -25%',
      leave: 'end 75%',
      sync: 0.5,
    }),
  });
})();
